
import { useFormik } from "formik";
import toast from "react-hot-toast";
import { Link } from 'react-router-dom';
import { object, string } from "yup";
import axios from "axios";
import AuthHeroSection from "./AuthHeroSection";
import AuthLangButton from "../../components/authLangButton/AuthLangButton";
import { FaChevronLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa";
import { useTranslation } from "react-i18next";


export default function ForgetPassword() {
  const baseUrl = import.meta.env.VITE_BASE_URL
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const lang = i18n.language 
  async function forgetPassword() {
    const toastId = toast.loading(t("forgetPassword.sending") as string)
    try {
      const options = {
        url: `${baseUrl}/api/dashboard/users/reset-password?locale=${lang}`,
        method: "POST",
        data: {
          email: formik.values.email
        }
      }
      const response = await axios.request(options)
      if (response.data.success == true) {
        localStorage.setItem("email", formik.values.email)
        toast.success(t("forgetPassword.emailSent") as string)


      } else {
        toast.error(t("forgetPassword.emailNotFound") as string)
      }
    } catch (error) {
      console.error(error);
      toast.error("An unexpected error occurred")
    } finally {
      toast.dismiss(toastId)
    }
  }
  // validationSchema
  const validationSchema = object({
    email: string().email(t("forgetPassword.invalidEmail") as string).required(t("forgetPassword.emailRequired") as string),
  })
  // controlled inputs
  const formik = useFormik({
    initialValues: {
      email: "",

    },
    validationSchema,
    onSubmit: forgetPassword,
  })


  return (
    <div className="xl:grid xl:grid-cols-12">

      <form
        onSubmit={formik.handleSubmit}
        className=" h-[75vh] relative mt-10 flex justify-between w-[90%] md:w-[60%] xl:w-[70%] mx-auto flex-col col-span-4 "
      >
        <AuthLangButton />
        <div className="flex flex-col gap-4 w-full  p-5 borderrounded-md">

          <h1 className="my-2  text-xl font-semibold">
            {t("forgetPassword.title")} 🔒
          </h1>
          <span className="text-slate-400">{t("forgetPassword.instruction")}</span>
          <div className="flex w-full  flex-col gap-3">
            <div className="flex flex-col gap-2">
              <label htmlFor="email" className="font-semibold">{t("forgetPassword.email")}</label>
              <input
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                value={formik.values.email}
                name="email"
                type="email"
                className="input"
                placeholder={t("forgetPassword.enterEmail") as string}
              />
              {formik.errors.email && formik.touched.email && <span className="text-red-500 text-sm">{formik.errors.email}</span>}
            </div>
            <button type="submit" className="my-btn">
              {t("forgetPassword.send")}
            </button>
            <div className="flex justify-center items-center gap-2">

              <Link to="/login" className="text-sidebar mx-auto flex items-center gap-2 "> {t("forgetPassword.backToLogin")}
                {isArabic ? <FaChevronLeft className="text-sm" /> : <FaChevronRight className="text-sm" />}

              </Link>
            </div>
          </div>
        </div>
      </form>
      <AuthHeroSection />
    </div>
  )
}
